import React from "react";
import { useNavigate } from "react-router-dom";
import BandhanLogo from "../../assets/BankLogo/bandhan.png";
import IndusIndLogo from "../../assets/BankLogo/indusland.png";
import HDFCLogo from "../../assets/BankLogo/hdfc.png";
import KotakLogo from "../../assets/BankLogo/kotak.png";


const PersonalLoanBankOffer = () => {
  const navigate = useNavigate();
  const plans = [
    {
      loanType: "personal",
      title: "Personal Loan",
    },
  ];

  const loanData = [
    {
      loanType: "Personal Loan",
      bank: "Bandhan Bank",
      loanAmount: "₹15L - ₹40L",
      interestRate: "Starting @ 10.25%",
      tenure: "Upto 60 Months",
      tag: "Real Time Offer",
      bankLogo: BandhanLogo,
    },
    {
      loanType: "Personal Loan",
      bank: "IndusInd Bank",
      loanAmount: "₹15L - ₹50L",
      interestRate: "Starting @ 10.35%",
      tenure: "Upto 84 Months",
      tag: "Real Time Offer",
      bankLogo: IndusIndLogo,
    },
    {
      loanType: "Personal Loan",
      bank: "HDFC Bank",
      loanAmount: "₹15L - ₹50L",
      interestRate: "Starting @ 10.75%",
      tenure: "Upto 72 Months",
      tag: "Real Time Offer",
      bankLogo: HDFCLogo,
    },
    {
      loanType: "Personal Loan",
      bank: "Kotak Bank",
      loanAmount: "₹15L - ₹20L",
      interestRate: "Starting @ 10.50%",
      tenure: "Upto 60 Months",
      tag: "Real Time Offer",
      bankLogo: KotakLogo,
    },
  ];

  const handleApplyClick = (loanType) => {
    navigate("/otp-verification", { state: { loanType } });
  };

  return (
    <div className="pricing-main-container">
      <h4 className="bank-offer-title">{loanData[0].loanType}</h4>
      <p className="bank-offer-description">
        “Check Your Eligibility – Get Instant Approval! <br /> Salaried
        individuals with a{" "}
        <span className="highlight-rate">net salary above ₹50,000 P/m</span> and
        above can apply here.”{" "}
      </p>

      <div className="pricing-cards">
        {loanData.map((loan, index) => (
          <div key={index} className="pricing-card">
            <div className="bank-header">
              <img src={loan.bankLogo} alt={loan.bank} className="bank-logo" />
              <h3 className="bank-name">{loan.bank}</h3>
            </div>
            <p>
              <strong>Loan Amount:</strong> {loan.loanAmount}
            </p>
            <p>
              <strong>Interest Rate:</strong> {loan.interestRate}
            </p>
            <p>
              <strong>Tenure:</strong> {loan.tenure}
            </p>
            <p className="offer-tag">{loan.tag}</p>
            {plans.map((plan, index) => (
              <button
                key={index}
                className="apply-button"
                onClick={() => handleApplyClick(plan.loanType)}
              >
                Check Eligibility
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default PersonalLoanBankOffer;
